import { useState } from "react";
import { useForm } from "react-hook-form";
import { FormControlLabel, Switch } from "@mui/material";
import Input from "../../../../components/input/Input";
import Select from "../../../../components/select/Select";
import Button from "../../../../components/Button";
import useUpdateCourse from "../hooks/useUpdateCourse";
import { useSchoolLevelOptions } from "../../../../hooks/useSchoolLevelOptions";

function UpdateCourse({ onCloseModal, oldData }) {
    const { id, grade, school_level, courseName, visibility, brief, typeOfCourse } = oldData;

    const [isVisibil, setIsVisibil] = useState(Boolean(visibility));

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
        setValue,
        getValues
    } = useForm({
        defaultValues: {
            grade,
            school_level,
            name: courseName,
            brief,
            type: typeOfCourse,
        },
    });

    const selectedSchoolLevel = getValues("school_level");

    const { isSchoolLevelOptionsLoading, schoolLevelOptions, gradesOptions } = useSchoolLevelOptions(selectedSchoolLevel);

    const { updateCourse, isUpdating, error: ApiError } = useUpdateCourse();

    function onSubmit({ name, brief, grade, type }) {
        updateCourse(
            {
                name,
                brief,
                school_level: selectedSchoolLevel,
                grade,
                visibility: isVisibil ? 1 : 0,
                courseId: id,
                type,
            },
            {
                onSuccess: () => {
                    reset();
                    onCloseModal?.();
                },
            }
        );
    }

    const handleChange = (event) => {
        setIsVisibil(event.target.checked);
    };

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col items-center justify-center w-full gap-3"
        >
            <h3 className="py-5 text-xl text-blue-color-primary">
                تعديل بيانات الكورس
            </h3>

            <FormControlLabel
                control={
                    <Switch
                        checked={isVisibil}
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                        color="primary"
                    />
                }
                label="مفعل"
            />

            <div className="w-full py-5 space-y-4">
                <Input
                    label="أسم الفصل الدراسي"
                    name="name"
                    register={register("name", {
                        maxLength: {
                            value: 70,
                            message: "أسم الفصل الدراسي يجب ان لا يزيد عن 70 حرف",
                        },
                        required: "يرجا إدخال أسم الفصل الدراسي",
                    })}
                    error={
                        errors?.name?.message ||
                        ApiError?.response?.data?.errors?.name?.[0]
                    }
                    type="text"
                    disabled={isUpdating}
                />

                <Input
                    label="الوصف"
                    name="brief"
                    register={register("brief", {
                        maxLength: {
                            value: 250,
                            message: "وصف الفصل الدراسي يجب ان لا يزيد عن 250 حرف",
                        },
                        required: "يرجا إدخال وصف الفصل الدراسي",
                    })}
                    error={
                        errors?.brief?.message ||
                        ApiError?.response?.data?.errors?.brief?.[0]
                    }
                    type="text"
                    disabled={isUpdating}
                />

                <Select
                    name="school_level"
                    label="المستوى الدراسي*"
                    disabled={isUpdating}
                    setValue={setValue}
                    watch={watch}
                    register={register("school_level", {
                        required: "الرجاء تحديد السنة الدراسية",
                    })}
                    error={
                        errors?.school_level?.message ||
                        ApiError?.response?.data?.errors?.school_level?.[0]
                    }
                    isOptionsLoading={isSchoolLevelOptionsLoading}
                    options={schoolLevelOptions}
                />

                <Select
                    name="grade"
                    label="الصف*"
                    disabled={isUpdating || !selectedSchoolLevel}
                    setValue={setValue}
                    watch={watch}
                    register={register("grade", {
                        required: "الرجاء تحديد السنة الدراسية",
                    })}
                    error={
                        errors?.grade?.message ||
                        ApiError?.response?.data?.errors?.grade?.[0]
                    }
                    isOptionsLoading={isSchoolLevelOptionsLoading}
                    options={gradesOptions}
                />

                <Select
                    name="type"
                    label="نوع الفصل الدراسي*"
                    disabled={isUpdating}
                    setValue={setValue}
                    watch={watch}
                    register={register("type", {
                        required: "الرجاء تحديد نوع الفصل الدراسي",
                    })}
                    error={
                        errors?.type?.message ||
                        ApiError?.response?.data?.errors?.grade?.[0]
                    }
                    options={[
                        { value: "1", text: "اونلاين" },
                        { value: "2", text: "سنتر" },
                    ]}
                />
            </div>

            <div className="w-full pt-3">
                <Button
                    type="primary"
                    className="w-full leading-8"
                    disabled={isUpdating}
                >
                    تعديل الفصل الدراسي
                </Button>
            </div>
        </form>
    );
}

export default UpdateCourse;
